module.exports = __webpack_public_path__ + "static/img/4_6_1.3168e3a6.jpg";